import { CancelToken } from 'axios'

import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils/axios'

import { BackupDocument } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<BackupDocument.Basic>> =>
	Http.get(baseUrl, { params })

export const searchSuggestions = (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<BackupDocument.Search.Result> =>
	Http.get(`${baseUrl}/search-suggestions`, { params, cancelToken })

export const downloadDocument = (fileName: string): Promise<Blob> =>
	Http.get(`${baseUrl}/download`, {
		responseType: 'blob',
		params: {
			fileName
		}
	})
